var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropiosEventos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.727,
    height: 113.737,
    viewBox: "0 0 113.727 113.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a4c2f7;}.b{fill:#d4e1f4;}.c{fill:#e3e7f2;}.d{fill:#efd2ff;}.e{fill:#f1eaf4;}.f{fill:#fff;}.g{fill:#264ecc;}.h{fill:#7821a0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-179.391 -908.425)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.391 908.425)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.895 1.896)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M291.208,921.591V980.35a5.681,5.681,0,0,1-5.687,5.687H186.958a5.68,5.68,0,0,1-5.687-5.687V921.591Z",
    transform: "translate(-181.271 -910.218)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M285.522,921.591V980.35a5.679,5.679,0,0,1-5.686,5.687H186.958a5.68,5.68,0,0,1-5.687-5.687V921.591Z",
    transform: "translate(-181.271 -910.218)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M247.912,1001.695l11.373,11.373a3.78,3.78,0,1,1-5.345,5.345l-11.373-11.373Z",
    transform: "translate(-180.794 -909.594)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 17.059,
    cy: 17.059,
    r: 17.059,
    transform: "translate(37.91 68.237)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.91 68.237)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 14.216,
    cy: 17.059,
    rx: 14.216,
    ry: 17.059
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 9.477,
    cy: 9.477,
    r: 9.477,
    transform: "translate(7.582 7.582)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M291.208,915.993v9.477H181.271v-9.477a5.681,5.681,0,0,1,5.687-5.687h98.564a5.681,5.681,0,0,1,5.687,5.687Z",
    transform: "translate(-181.271 -910.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M285.522,915.993v9.477H181.271v-9.477a5.681,5.681,0,0,1,5.687-5.687h92.878a5.679,5.679,0,0,1,5.686,5.687Z",
    transform: "translate(-181.271 -910.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M198.272,932.876l2.928,6.24,6.549,1-4.739,4.856,1.118,6.858-5.857-3.238-5.857,3.238,1.118-6.858-4.739-4.856,6.549-1Z",
    transform: "translate(-181.212 -910.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M198.272,957.327l2.928,6.24,6.549,1-4.739,4.856,1.118,6.858-5.857-3.238-5.857,3.238,1.118-6.858-4.739-4.856,6.549-1Z",
    transform: "translate(-181.212 -909.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M186.958,986.125h5.686a5.678,5.678,0,0,1-5.686-5.686V915.993a5.679,5.679,0,0,1,5.686-5.687h-5.686a5.681,5.681,0,0,0-5.687,5.687v64.445a5.681,5.681,0,0,0,5.687,5.687Z",
    transform: "translate(-181.271 -910.306)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M183.182,925.353v54.969h-3.791V925.353Z",
    transform: "translate(-179.391 -908.293)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M235.9,983.658a11.373,11.373,0,1,0,11.373,11.373A11.373,11.373,0,0,0,235.9,983.658Zm0,18.954a7.582,7.582,0,1,1,7.582-7.582A7.581,7.581,0,0,1,235.9,1002.612Z",
    transform: "translate(-179.039 -907.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M181.286,942.309a2,2,0,0,0,1.346-.549,1.923,1.923,0,0,0,0-2.692l-.284-.228a1.455,1.455,0,0,0-.342-.171,1.2,1.2,0,0,0-.342-.113,2.794,2.794,0,0,0-.379-.038,1.987,1.987,0,0,0-1.345.55,1.868,1.868,0,0,0,.625,3.089A1.887,1.887,0,0,0,181.286,942.309Z",
    transform: "translate(-179.391 -908.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M285.536,908.425H186.973a7.59,7.59,0,0,0-7.582,7.583v17.059a1.9,1.9,0,1,0,3.79,0V927.38h90.982a1.9,1.9,0,1,0,0-3.79H183.181v-7.582a3.8,3.8,0,0,1,3.791-3.791h98.564a3.8,3.8,0,0,1,3.791,3.791v7.582h-7.582a1.9,1.9,0,1,0,0,3.79h7.582v53.073a3.8,3.8,0,0,1-3.791,3.791H251.381a18.881,18.881,0,0,0-30.254,0H186.973a3.8,3.8,0,0,1-3.791-3.791V948.231a1.9,1.9,0,1,0-3.79,0v32.223a7.589,7.589,0,0,0,7.582,7.582h31.921a18.931,18.931,0,0,0,26.125,24.372l8.075,8.074a5.675,5.675,0,1,0,8.024-8.028l-8.072-8.072a18.832,18.832,0,0,0,.57-16.346h31.921a7.588,7.588,0,0,0,7.582-7.582V916.008A7.589,7.589,0,0,0,285.536,908.425ZM221.09,995.617a15.164,15.164,0,1,1,15.164,15.164A15.164,15.164,0,0,1,221.09,995.617Zm37.355,19.527a1.845,1.845,0,0,1-.006,2.655,1.9,1.9,0,0,1-2.667,0l-7.522-7.522a19.152,19.152,0,0,0,2.666-2.666Z",
    transform: "translate(-179.391 -908.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M218.9,915.949a1.9,1.9,0,1,0,0,3.79H253.02a1.9,1.9,0,1,0,0-3.79Z",
    transform: "translate(-179.098 -908.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M209.561,939.529a1.894,1.894,0,0,0-1.51-1.272l-5.55-.849-2.5-5.323a1.9,1.9,0,0,0-3.431,0l-2.5,5.323-5.55.849a1.895,1.895,0,0,0-1.069,3.2l4.07,4.172-.964,5.914a1.9,1.9,0,0,0,2.788,1.964l4.94-2.73,4.94,2.73a1.9,1.9,0,0,0,2.789-1.964l-.965-5.914,4.07-4.172A1.9,1.9,0,0,0,209.561,939.529Zm-7.893,4.135a1.9,1.9,0,0,0-.514,1.629l.49,3.006-2.441-1.349a1.9,1.9,0,0,0-1.833,0l-2.441,1.349.491-3.006a1.9,1.9,0,0,0-.515-1.629l-2.162-2.216,2.9-.443a1.9,1.9,0,0,0,1.429-1.068l1.212-2.584,1.212,2.584A1.894,1.894,0,0,0,200.927,941l2.9.443Z",
    transform: "translate(-179.332 -908.249)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M187.452,965.9l4.07,4.172-.964,5.915a1.9,1.9,0,0,0,2.788,1.964l4.941-2.731,4.94,2.731a1.9,1.9,0,0,0,2.788-1.964l-.964-5.915,4.07-4.172a1.9,1.9,0,0,0-1.069-3.2l-5.55-.847-2.5-5.324a1.9,1.9,0,0,0-3.432,0l-2.5,5.324-5.55.847a1.9,1.9,0,0,0-1.07,3.2Zm8.193-.449a1.894,1.894,0,0,0,1.429-1.068l1.212-2.584,1.212,2.584a1.892,1.892,0,0,0,1.428,1.068l2.9.444-2.163,2.215a1.9,1.9,0,0,0-.514,1.63l.49,3.006L199.2,971.4a1.889,1.889,0,0,0-1.833,0l-2.442,1.349.491-3.006a1.9,1.9,0,0,0-.515-1.63l-2.162-2.215Z",
    transform: "translate(-179.332 -908.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M217.022,936.667h11.373a1.9,1.9,0,0,0,0-3.791H217.022a1.9,1.9,0,0,0,0,3.791Z",
    transform: "translate(-179.113 -908.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M217.022,944.19h24.641a1.9,1.9,0,0,0,0-3.791H217.022a1.9,1.9,0,1,0,0,3.791Z",
    transform: "translate(-179.113 -908.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M264.159,940.4H249a1.9,1.9,0,1,0,0,3.791h15.163a1.9,1.9,0,1,0,0-3.791Z",
    transform: "translate(-178.864 -908.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M279.147,944.19a1.9,1.9,0,1,0,0-3.791h-7.582a1.9,1.9,0,1,0,0,3.791Z",
    transform: "translate(-178.688 -908.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M250.862,949.818a1.894,1.894,0,0,0,1.895,1.9h26.537a1.9,1.9,0,1,0,0-3.79H252.757a1.893,1.893,0,0,0-1.895,1.895Z",
    transform: "translate(-178.834 -908.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M245.351,947.923H230.188a1.9,1.9,0,1,0,0,3.79h15.163a1.9,1.9,0,1,0,0-3.79Z",
    transform: "translate(-179.01 -908.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M217.022,951.713h5.686a1.9,1.9,0,1,0,0-3.79h-5.686a1.9,1.9,0,1,0,0,3.79Z",
    transform: "translate(-179.113 -908.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M217.022,963h11.373a1.9,1.9,0,1,0,0-3.79H217.022a1.9,1.9,0,1,0,0,3.79Z",
    transform: "translate(-179.113 -908.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M217.022,970.521h24.641a1.9,1.9,0,0,0,0-3.79H217.022a1.9,1.9,0,1,0,0,3.79Z",
    transform: "translate(-179.113 -907.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M249,970.521h15.163a1.9,1.9,0,1,0,0-3.79H249a1.9,1.9,0,1,0,0,3.79Z",
    transform: "translate(-178.864 -907.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M279.147,966.731h-7.582a1.9,1.9,0,1,0,0,3.79h7.582a1.9,1.9,0,1,0,0-3.79Z",
    transform: "translate(-178.688 -907.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M279.294,974.254H252.757a1.9,1.9,0,0,0,0,3.791h26.537a1.9,1.9,0,0,0,0-3.791Z",
    transform: "translate(-178.834 -907.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M217.022,978.045h3.791a1.9,1.9,0,0,0,0-3.791h-3.791a1.9,1.9,0,0,0,0,3.791Z",
    transform: "translate(-179.113 -907.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M189.344,916.5a2.175,2.175,0,0,0-.4.626,1.587,1.587,0,0,0-.152.72,1.871,1.871,0,0,0,.132.72,2.863,2.863,0,0,0,.418.626,1.875,1.875,0,0,0,2.066.4,1.708,1.708,0,0,0,1.024-1.024,1.893,1.893,0,0,0-3.09-2.066Z",
    transform: "translate(-179.318 -908.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M196.867,916.5a2.2,2.2,0,0,0-.4.626,1.586,1.586,0,0,0-.151.72,1.87,1.87,0,0,0,.131.72,2.9,2.9,0,0,0,.418.626,1.875,1.875,0,0,0,2.066.4,1.708,1.708,0,0,0,1.024-1.024,1.922,1.922,0,0,0,.152-.72,1.9,1.9,0,0,0-3.242-1.346Z",
    transform: "translate(-179.259 -908.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M204.391,916.5a2.154,2.154,0,0,0-.4.626,1.574,1.574,0,0,0-.152.72,1.852,1.852,0,0,0,.132.72,2.825,2.825,0,0,0,.418.626,1.874,1.874,0,0,0,2.065.4,2.206,2.206,0,0,0,.626-.4,2.182,2.182,0,0,0,.4-.626,1.892,1.892,0,0,0-3.089-2.066Z",
    transform: "translate(-179.201 -908.366)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(217.301 976.662)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M235.9,983.659a11.374,11.374,0,1,0,11.374,11.374A11.374,11.374,0,0,0,235.9,983.659Zm0,18.956a7.583,7.583,0,1,1,7.583-7.583A7.583,7.583,0,0,1,235.9,1002.615Z",
    transform: "translate(-216.949 -976.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M260.82,1011.93l-8.073-8.072q.262-.5.491-1.008c.04-.091.077-.183.116-.274.109-.253.217-.507.314-.763.037-.1.069-.193.1-.29.094-.258.184-.516.266-.777.027-.087.051-.173.077-.26.084-.276.161-.554.231-.833.018-.072.033-.143.05-.215.072-.3.136-.6.191-.9.01-.052.019-.106.028-.158q.086-.488.147-.979l.012-.1q.062-.525.094-1.05l0-.045a18.812,18.812,0,0,0-1.554-8.692h.1a18.994,18.994,0,0,0-2.2-3.791h-.138a18.884,18.884,0,0,0-30.258,0h-.138a19,19,0,0,0-2.2,3.791h.1a18.875,18.875,0,0,0-1.495,9.425c0,.038.006.076.01.114.03.3.068.6.113.893.006.044.014.088.021.132q.124.781.313,1.55c.026.107.05.214.079.32.066.246.134.491.209.734.047.155.1.309.152.463.114.34.236.676.369,1.009.082.2.163.4.251.6.079.178.159.356.244.531.128.268.263.532.4.794q.125.236.258.467.245.425.511.84c.078.12.156.239.237.357.224.331.454.656.7.974l.084.106c.253.321.52.634.8.941q.115.128.233.254c.3.323.609.639.934.943a18.933,18.933,0,0,0,21.7,2.925l8.074,8.075a5.676,5.676,0,1,0,8.026-8.029Zm-24.865-1.673a15.165,15.165,0,1,1,15.165-15.165A15.184,15.184,0,0,1,235.954,1010.257Zm22.185,7.017a1.9,1.9,0,0,1-2.667,0l-7.457-7.457-.065-.066a19.077,19.077,0,0,0,2.666-2.665l.065.065h0l7.467,7.466a1.845,1.845,0,0,1-.008,2.654Z",
    transform: "translate(-217.008 -976.135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropiosEventos);
export default __webpack_public_path__ + "static/media/propios_eventos.81a92dbdd541ddfd3f1af7e2e36fcc28.svg";
export { ForwardRef as ReactComponent };